<template>
    <div class="autocomplete">
        <v-menu
            offset-y
            :close-on-content-click="!multiple"
            v-model="menu"
        >
            <template v-slot:activator="{ on, attrs }">
                <div
                    @click="menu = true"
                    class="autocomplete-block"
                    :class="{'active-border': menu }"
                    v-on="on"
                    v-bind="attrs"
                >
                    <div class="autocomplete-block__selections">
                        <div
                            v-show="isSelected"
                            class="autocomplete-block__selections__comma"
                            v-for="(item, ind) in selected"
                            :key="'P'+ind"
                        >
                            {{ `${item.name}${selected.length > 1 && ind !== selected.length-1 ? ',' : ''}` }}
                        </div>

                        <input
                            @input="onMenu"
                            :placeholder="isSelected ? '' : placeholder"
                            type="text"
                            autocomplete="off"
                        >
                    </div>
                    <v-icon v-if="isSelected && clearable" :color="menu ? '#1976d2' : '#abaeb7'" @click="resetSelected">
                        mdi-close
                    </v-icon>
                    <v-icon :color="menu ? '#1976d2' : '#abaeb7'">
                        {{ menu ? 'mdi-menu-up' : 'mdi-menu-down' }}
                    </v-icon>
                </div>
            </template>

            <v-list class="autocomplete-item">
                <v-list-item
                    v-for="(item, i) in showData"
                    v-show="showData.length > 0"
                    :key="'R'+i"
                >
                    <v-list-item-action @click="selectedItem(item)">
                        <v-checkbox readonly :disabled="!item.isVisible" :ripple="false" v-model="item.checkbox" />
                    </v-list-item-action>
                    <v-list-item-content @click="selectedItem(item)">
                        <v-list-item-title>
                            <v-row no-gutters align="center">
                                <p :class="{'disabled': !item.isVisible }" class="title">{{ item[itemText] }}</p>
                            </v-row>
                        </v-list-item-title>
                    </v-list-item-content>

                    <v-btn v-show="!getFlagReadonly" :title="item.isVisible ? 'Скрыть' : 'Показать'" :loading="item.loadingDisabled" absolute right icon @click="disabledGroup(item)">
                        <v-icon color="#1976d2">
                            {{ !item.isVisible ? 'mdi-eye' : 'mdi-eye-off' }}
                        </v-icon>
                    </v-btn>
                </v-list-item>

                <v-list-item v-show="showData.length === 0">
                    <v-list-item-content>
                        <v-list-item-title>
                            <v-row no-gutters align="center">
                                Данные отсутствуют
                            </v-row>
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-menu>

        <v-progress-linear
            v-if="loading"
            indeterminate
            color="#1976d2"
            height="2px"
        />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    props: {
        items: { type: Array, default: () => [] },
        multiple: { type: Boolean, default: () => false },
        loading: { type: Boolean, default: () => false },
        clearable: { type: Boolean, default: () => false },
        placeholder: { type: String, default: () => '' },
        itemText: { type: String, default: () => 'name' },
        optionsApi: { type: Object, default: () => ({ url: '', physResearchId: null }) }
    },
    computed: {
        ...mapGetters({
            apiUrl: 'apiUrl',
            getFlagReadonly: 'createDiagnosticTest/getFlagReadonly'
        }),
        showData() {
            if (this.search && this.search.length > 0) {
                return this.items.filter((f) => f.name.toLocaleLowerCase().indexOf(this.search.toLocaleLowerCase()) > -1 );
            }

            console.log('showData', this.items);
            return this.items
        },
        isSelected() {
            if(this.selected && this.selected.length > 0) {
                return true
            }

            return false
        }
    },
    data: () => ({
        selected: [],
        menu: false,
        search: ''
    }),
    methods: {
        selectedItem(item) {
            item.checkbox = !item.checkbox;

            let index = this.selected.indexOf(item);
            if(index > -1) {
                this.selected.splice(index, 1);
            } else {
                this.selected.push(item);
            }

			this.$emit('change', this.selected.map((m) => m.id));
        },
        onMenu(event) {
            this.search = event.target.value;
            if(this.menu) return;
            this.menu = true;
        },
        resetSelected() {
            if(this.selected.length > 0) {
                this.selected = [];

                for (let i = 0; i < this.items.length; i++) {
                    this.items[i].checkbox = false;
                }
            }

            this.$emit('change', this.selected.map((m) => m.id));
        },
        disabledGroup(item) {
            // Если при скрытии группы она выбрана для фильтра, надо очистить
            if(item.checkbox) {
                let index = this.selected.indexOf(item);
                item.checkbox = false;

                if(index > -1) this.selected.splice(index, 1);
            }

            item.isVisible = !item.isVisible;
            item.loadingDisabled = true;

            this.$http.post(`${this.apiUrl}${this.optionsApi.url}?testId=${this.$route.params.id}&groupId=${item.id}&visible=${item.isVisible}${this.optionsApi.physResearchId ? '&physResearchId='+this.optionsApi.physResearchId : ''}`, {
                testId: this.$route.params.id,
                physResearchId: this.optionsApi.physResearchId,
                groupId: item.id,
                visible: item.isVisible
            })
            .then(() => {
                this.snackbar = { text: `Группа успешно ${item.isVisible ? 'показана' : 'скрыта'}!`, color: 'success', timeout: 3000, show: true };
                item.loadingDisabled = false;
                this.$emit('hideOrShowGroup', this.selected.map((m) => m.id));

            })
            .catch((error) => {
                if(error) {
                    this.snackbar = { text: 'Ошибка, обратитесь к Администратору!', color: 'error', timeout: 3000, show: true };
                }
            })
        }
    },
    mounted() {
        this.$root.$on('resetSelected', () => { this.resetSelected() })
    }
}
</script>

<style src="./index.scss" lang="scss" scoped />